(ns pfo.document.core
  (:require [secretary.core :as secretary :refer-macros [defroute]]
            [reagent.session :as session]
            [promesa.core :as p]
            [pfo.auth.model :as auth-model :refer [filter-families]]
            [pfo.document.component :as component :refer [ui-state-value]]
            [pfo.document.model :as model]
            [pfo.link.core :as link]
            [pfo.link.model :as link-model]
            [pfo.collection.model :as collection-model]
            [pfo.staging.workspace :as staging-workspace]
            [pfo.common.component :refer [empty-page]]
            [pfo.api :refer [process-error]]
            [pfo.state :refer [ui-state]]
            [pfo.util :as util :refer [split-string] :rename {split-string split}]))

(defn document-add [{:keys [query-params]}]
  (if-let [collection-id (not-empty (:collection_id query-params))]
    (->> (p/all [(collection-model/collection-details collection-id)
                 (collection-model/permitted-groups collection-id)])
         (p/map (fn [[collection permitted-groups]]
                  (util/set-page (#'component/document-edit collection nil (link/parent-info query-params) (filter-families permitted-groups :can_add_document)))))
         (process-error))
    (->> (collection-model/permitted-groups nil)
         (p/map (fn [permitted-groups]
                  (util/set-page (#'component/document-edit nil nil nil (filter-families permitted-groups :can_add_document)))))))
  (util/set-initial-page empty-page))

(defn document-edit [{:keys [id]}]
  (->> (model/document-details id)
       (p/map (fn [details-response]
                (->> (collection-model/permitted-groups (:collection_id (first (:document_collections details-response))))
                     (p/map (fn [permitted-groups]
                              (util/set-page (#'component/document-edit nil details-response nil permitted-groups)))))))
       (process-error))
  (util/set-initial-page empty-page))

(defn document-details [{:keys [id query-params]}]
  (->> (model/document-details id)
       (p/map (fn [details-response]
                (util/set-page #'component/document-details {:highlight-comment-id (util/somestr-to-int (:comment_id query-params))} details-response)))
       (process-error))
  (util/set-initial-page empty-page))

(defn document-list [{:keys [query-params]}]
  (let [page (if-let [page (:page query-params)] (js/parseInt page) (or (ui-state-value :page) 1))
        category (:category query-params)
        collection-id (util/somestr-to-int (:collection_id query-params))]
    (->> (model/document-list nil page "-created_at"
           {:collection-id collection-id
            :include-subcollections (or (ui-state-value :include-subcollections) (boolean collection-id))
            :include-linked-to-other-parents (ui-state-value :include-linked-to-other-parents)
            :period (ui-state-value :period)
            :period-exclude (ui-state-value :period-exclude)
            :collection-types (ui-state-value :collection-types)
            :collection-types-exclude  (ui-state-value :collection-types-exclude)
            :categories (or category (ui-state-value :categories))
            :categories-exclude (ui-state-value :categories-exclude)
            :creator-users (ui-state-value :creator-users)
            :creator-users-exclude (ui-state-value :creator-users-exclude)
            :created-at-period (ui-state-value :created-at-period)
            :created-at-period-exclude (ui-state-value :created-at-period-exclude)}
           nil)
         (p/map (fn [documents-response]
                  (util/set-page #'component/main-document-list {:page page} documents-response)))
         (process-error))))

(defn add-or-choose [{:keys [query-params]}]
  (let [collection-id (not-empty (:collection_id query-params))
        parent-info (link/parent-info query-params)]
    (->> (link-model/object (:parent-type parent-info) (:parent-id parent-info) (:complete-by parent-info))
         (p/map (fn [object-response]
                  (->> (collection-model/permitted-groups collection-id)
                       (p/map (fn [permitted-groups]
                                (util/set-page
                                  (#'component/document-add-or-choose
                                    nil (assoc parent-info :object object-response) permitted-groups))))
                       (process-error))))
         (process-error)))
  (util/set-initial-page empty-page))

(defn unfiled-list [{:keys [query-params]}]
  ;; Standalone Unfiled review workspace. It loads its own data (the staging
  ;; queue) via the controller, so there is nothing to fetch here — just mount
  ;; the page, optionally focusing a specific staged document.
  (util/set-page #'staging-workspace/unfiled-page
    {:focus (util/somestr-to-int (:focus query-params))}))

(defn signature-wait []
  (util/set-page #'component/signature-wait))
